import React, { createContext, useContext, useEffect, useState } from 'react';
import { WarehousesQuery } from '../../../generated/graphql';

interface ContextProps {
    currentWarehouseId: string | null;
    switchWarehouse: (warehouseId: string) => void;
    warehouses: WarehousesQuery['warehouses'];
}

const defaultState = {
    currentWarehouseId: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    switchWarehouse: () => {},
    warehouses: [],
};

const WarehouseScopeContext = createContext<ContextProps>(defaultState);

interface WarehouseScopeProviderProps {
    warehouses: WarehousesQuery['warehouses'];
}

export const WarehouseScopeProvider: React.FC<WarehouseScopeProviderProps>= ({ children, warehouses }) => {
    const [currentWarehouseId, setCurrentWarehouseId] = useState(warehouses.length > 0 ? warehouses[0].id : null);

    const warehouseContext = {
        warehouses,
        currentWarehouseId,
        switchWarehouse: setCurrentWarehouseId,
    };

    useEffect(() => {
        if (!currentWarehouseId && warehouses.length > 0) {
            setCurrentWarehouseId(warehouses[0].id);
        }
    }, [currentWarehouseId, warehouses]);

    return (
        <WarehouseScopeContext.Provider value={warehouseContext}>
            {children}
        </WarehouseScopeContext.Provider>
    );
};

export const useWarehousesScope = () => {
    return useContext(WarehouseScopeContext);
};
